var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { staticClass: "registry-paper registry-profile p-4" },
    [
      _c(
        "header",
        {
          staticClass: "d-flex justify-content-between align-items-start mb-3",
        },
        [
          _c("div", [
            _c("div", { staticClass: "small text-muted" }, [
              _vm._v(_vm._s(_vm.label(_vm.entity.type))),
            ]),
            _c("h2", { staticClass: "h4 mb-1" }, [
              _vm._v(_vm._s(_vm.recordName(_vm.entity))),
            ]),
            _vm.possible
              ? _c("div", { staticClass: "small text-warning" }, [
                  _vm._v(
                    "Possible affiliation. No confirmed relationship is implied."
                  ),
                ])
              : _vm._e(),
          ]),
          _vm.canUpdate &&
          _vm.detailTab === "overview" &&
          _vm.editingSection !== "details"
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-primary ml-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.edit("details")
                    },
                  },
                },
                [_vm._v("Edit")]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.association
        ? _c("p", { staticClass: "small alert alert-info" }, [
            _vm._v(
              "Associated with a supplier location on " +
                _vm._s(_vm.date(_vm.association.at)) +
                ". "
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-link p-0",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("open-entity", {
                      type: "location",
                      id: _vm.association.supplier_location_id,
                    })
                  },
                },
              },
              [_vm._v("Open supplier location")]
            ),
            _vm._v(
              ". Existing orders keep their recorded location. This record takes no new links."
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.associatedManual.length
        ? _c(
            "div",
            { staticClass: "small mb-3" },
            [
              _vm._v("Associated manual locations: "),
              _vm._l(_vm.associatedManual, function (id) {
                return _c(
                  "button",
                  {
                    key: id,
                    staticClass: "btn btn-sm btn-link",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("open-entity", {
                          type: "location",
                          id,
                        })
                      },
                    },
                  },
                  [_vm._v("Open manual location")]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass: "nav nav-tabs mb-3",
          attrs: { "aria-label": "Entity details" },
        },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "button",
            {
              key: tab.key,
              staticClass: "nav-link",
              class: { active: _vm.detailTab === tab.key },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("tab", tab.key)
                },
              },
            },
            [_vm._v(_vm._s(tab.label))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.detailTab === "overview",
              expression: "detailTab === 'overview'",
            },
          ],
        },
        [
          _vm.editingSection === "details"
            ? _c("RegistryFieldEditor", {
                key: `${_vm.entity.type}:${_vm.entity.id}:details`,
                ref: "editor",
                attrs: {
                  record: _vm.entity,
                  kind: "entity",
                  "can-update": _vm.canUpdate,
                  metadata: _vm.metadata,
                },
                on: {
                  saved: _vm.saved,
                  cancel: _vm.cancelEdit,
                  reload: function ($event) {
                    return _vm.$emit("reload")
                  },
                },
              })
            : _c(
                "dl",
                { staticClass: "registry-facts mb-3" },
                _vm._l(_vm.facts, function (fact) {
                  return _c("div", { key: fact.key }, [
                    _c("dt", [_vm._v(_vm._s(fact.label))]),
                    _c("dd", [_vm._v(_vm._s(fact.value))]),
                  ])
                }),
                0
              ),
          _vm._v(" "),
          _vm._l(_vm.addressSections, function (group) {
            return _c(
              "section",
              { key: group.key, staticClass: "mt-3" },
              [
                _c("div", { staticClass: "registry-section-heading" }, [
                  _c("h3", [_vm._v(_vm._s(group.label))]),
                  _vm.canUpdate && _vm.editingSection !== group.key
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-link",
                          attrs: {
                            type: "button",
                            "aria-label": `Edit ${group.label.toLowerCase()}`,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.edit(group.key)
                            },
                          },
                        },
                        [_vm._v("Edit")]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.editingSection === group.key
                  ? _c("RegistryFieldEditor", {
                      key: `${_vm.entity.type}:${_vm.entity.id}:${group.key}`,
                      ref: "addressEditor",
                      refInFor: true,
                      attrs: {
                        record: _vm.entity,
                        kind: "entity",
                        section: group.key,
                        "can-update": _vm.canUpdate,
                        metadata: _vm.metadata,
                      },
                      on: {
                        saved: _vm.saved,
                        cancel: _vm.cancelEdit,
                        reload: function ($event) {
                          return _vm.$emit("reload")
                        },
                      },
                    })
                  : [
                      _c("div", { staticClass: "small" }, [
                        _vm._v(_vm._s(_vm.address(group.fact.values))),
                      ]),
                      group.key === "address" && _vm.missingParts.length
                        ? _c("small", { staticClass: "text-warning" }, [
                            _vm._v(
                              "Missing " +
                                _vm._s(
                                  _vm.missingParts.map(_vm.label).join(", ")
                                ) +
                                _vm._s(
                                  _vm.entity.type === "location"
                                    ? " for order placement"
                                    : ""
                                ) +
                                "."
                            ),
                          ])
                        : _vm._e(),
                      group.key === "address" && _vm.entity.type === "company"
                        ? _c("small", { staticClass: "d-block text-muted" }, [
                            _vm._v(
                              "Company address is evidence only; it does not substitute for a physical location."
                            ),
                          ])
                        : _vm._e(),
                    ],
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "mt-4" },
            [
              _c("div", { staticClass: "registry-section-heading" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.entity.type === "contact"
                        ? "Reported affiliations"
                        : "Reported connections"
                    )
                  ),
                ]),
                _vm.canUpdate && _vm.entity.type !== "company"
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-link",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("action", {
                              kind: "entity-links",
                              entity: _vm.entity,
                            })
                          },
                        },
                      },
                      [_vm._v("Manage links")]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "small text-muted" }, [
                _vm._v(
                  "Reported connections and titles do not establish ownership or authority."
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.entity.links || [], function (link, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "small border-bottom py-2" },
                  [
                    _c("span", { staticClass: "text-muted mr-2" }, [
                      _vm._v(_vm._s(_vm.role(link.role))),
                    ]),
                    link.resolved
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-link p-0",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("open-entity", link.resolved)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.text(
                                  link.resolved.name,
                                  `Unnamed ${link.resolved.type}`
                                )
                              )
                            ),
                          ]
                        )
                      : (link.candidates || []).length
                      ? _vm._l(link.candidates, function (candidate) {
                          return _c("span", { key: _vm.typedKey(candidate) }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-link",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("open-entity", {
                                      ...candidate,
                                      possible: true,
                                    })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.text(
                                      candidate.name,
                                      `Unnamed ${candidate.type}`
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" Possible " + _vm._s(candidate.type)),
                          ])
                        })
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              link.resolution === "suppressed"
                                ? "Source relationship suppressed"
                                : "No resolved record"
                            )
                          ),
                        ]),
                    _c("details", [
                      _c("summary", [_vm._v("Relationship evidence")]),
                      _c("pre", [_vm._v(_vm._s(_vm.json(link)))]),
                    ]),
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.canAssociate && _vm.canUpdate
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-outline-primary mt-3",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("action", {
                            kind: "associate-location",
                            entity: _vm.entity,
                          })
                        },
                      },
                    },
                    [_vm._v("Associate with supplier location")]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.inbound, function (group) {
            return _c("section", { key: group.key, staticClass: "mt-3" }, [
              _c(
                "details",
                [
                  _c("summary", [
                    _vm._v(
                      _vm._s(group.label) +
                        " (" +
                        _vm._s(group.value.total) +
                        ")"
                    ),
                  ]),
                  _vm._l(group.value.items, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "small mt-2" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-link p-0",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.openInbound(group.key, item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.inboundName(group.key, item)))]
                        ),
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v(
                            " · " +
                              _vm._s(_vm.role(item.role)) +
                              " · " +
                              _vm._s(
                                item.resolution === "ambiguous_candidate"
                                  ? "Possible affiliation"
                                  : _vm.label(item.resolution)
                              )
                          ),
                        ]),
                      ]
                    )
                  }),
                  group.value.total > group.value.items.length
                    ? _c("p", { staticClass: "small text-muted mt-2" }, [
                        _vm._v(
                          "Showing " +
                            _vm._s(group.value.items.length) +
                            " of " +
                            _vm._s(group.value.total) +
                            " references. This is a partial list of references, not a count of affected licenses."
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("RegistryEvidence", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.detailTab !== "overview",
            expression: "detailTab !== 'overview'",
          },
        ],
        attrs: {
          record: _vm.entity,
          section: _vm.detailTab,
          "can-update": _vm.canUpdate,
        },
        on: {
          action: function ($event) {
            return _vm.$emit("action", $event)
          },
          "open-license": function ($event) {
            return _vm.$emit("open-license", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }